import React from 'react';
export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const service = form.service.value;
    const message = form.message.value;

    const mailSubject = `New Contact From ${name}`;

    const mailBody = `Name: ${name}%0D%0AEmail: ${email}%0D%0APhone: ${phone}%0D%0AService: ${service}%0D%0A%0D%0AMessage:%0D%0A${message}`;

    window.location.href = `mailto:praneeshinfotech@gmail.com?subject=${mailSubject}&body=${mailBody}`;
  };

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="uppercase tracking-[3px] text-[#0a8082] font-semibold mb-4">
            Contact Us
          </p>

          <h2 className="text-5xl font-bold text-[#071E56] mb-6">
            Let's Discuss Your Project
          </h2>

          <p className="text-gray-600 text-lg leading-8 max-w-4xl mx-auto">
            We are here to help you build modern digital solutions for your business growth. Contact us for websites, mobile apps, ecommerce solutions, ERP software, and more.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[420px_1fr] gap-6 lg:gap-10 items-start">
          <div className="bg-gradient-to-br from-[#0a8082] to-[#071E56] rounded-[25px] sm:rounded-[35px] p-5 sm:p-8 lg:p-10 text-white shadow-2xl lg:sticky lg:top-28">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 sm:mb-10 leading-tight">
              Contact Information
            </h3>

            <div className="space-y-6 sm:space-y-8 text-base sm:text-lg leading-7 sm:leading-8">
              <div className="flex gap-5 items-start">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-white/20 flex items-center justify-center text-2xl sm:text-3xl shrink-0">
                  📍
                </div>

                <div>
                  <h4 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 leading-tight">Office Address</h4>
                  <p className="text-gray-100 leading-8">
                    27-B/5, Ayyampalayam Pudur,
                    Ayyampalayam (Post),
                    Kavindapadi - Erode - 638455
                  </p>
                </div>
              </div>

              <div className="flex gap-5 items-start">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-white/20 flex items-center justify-center text-2xl sm:text-3xl shrink-0">
                  📞
                </div>

                <div>
                  <h4 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 leading-tight">Phone Number</h4>
                  <a
                    href="tel:+919487924282"
                    className="text-gray-100 hover:text-white transition"
                  >
                    +91 94879 24282
                  </a>
                </div>
              </div>

              <div className="flex gap-5 items-start">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-white/20 flex items-center justify-center text-2xl sm:text-3xl shrink-0">
                  ✉️
                </div>

                <div>
                  <h4 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 leading-tight">Email Address</h4>
                  <a
                    href="mailto:praneeshinfotech@gmail.com"
                    className="text-gray-100 hover:text-white transition"
                  >
                    praneeshinfotech@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex gap-5 items-start">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-white/20 flex items-center justify-center text-2xl sm:text-3xl shrink-0">
                  🌐
                </div>

                <div>
                  <h4 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 leading-tight">Website</h4>
                  <a
                    href="https://praneeshinfotech.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-100 hover:text-white transition"
                  >
                    www.praneeshinfotech.com
                  </a>
                </div>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/dir//Pranesh+infotech,+Ayyampalayam+pudhur,+Kavandapadi,+Tamil+Nadu+638455/@11.4500404,77.5504773,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3ba915a1aaadaa73:0xb94dafe76f0b2389!2m2!1d77.5383385!2d11.4304405!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDUyMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 sm:mt-10 inline-flex items-center justify-center gap-3 bg-white text-[#0a8082] px-5 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-sm sm:text-base w-full sm:w-auto hover:scale-105 transition duration-300 shadow-xl"
            >
              Open Google Maps 📍
            </a>
          </div>

          <div className="space-y-10">
            <div className="bg-white rounded-[35px] shadow-2xl overflow-hidden border border-gray-100">
              <iframe
                src="https://www.google.com/maps?q=Praneesh+Infotech+Kavindapadi&output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Praneesh Infotech Location"
              ></iframe>
            </div>

            <div className="bg-white rounded-[25px] sm:rounded-[35px] p-5 sm:p-8 lg:p-10 shadow-2xl border border-gray-100">
              <div className="mb-10">
                <h3 className="text-4xl font-bold text-[#071E56] mb-4">
                  Send Us A Message
                </h3>

                <p className="text-base sm:text-lg leading-7 sm:leading-8">
                  Fill out the form below and our team will contact you shortly.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
                  <div>
                    <label className="block text-base sm:text-lg font-semibold text-[#071E56] mb-2 sm:mb-3">
                      Full Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Enter your name"
                      className="w-full border border-gray-300 rounded-2xl px-4 sm:px-6 py-3 sm:py-4 text-base sm:text-lg focus:outline-none focus:border-[#0a8082]"
                    />
                  </div>

                  <div>
                    <label className="block text-base sm:text-lg font-semibold text-[#071E56] mb-2 sm:mb-3">
                      Email Address
                    </label>

                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="Enter your email"
                      className="w-full border border-gray-300 rounded-2xl px-6 py-4 text-lg focus:outline-none focus:border-[#0a8082]"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
                  <div>
                    <label className="block text-base sm:text-lg font-semibold text-[#071E56] mb-2 sm:mb-3">
                      Phone Number
                    </label>

                    <input
                      type="tel"
                      name="phone"
                      required
                      placeholder="Enter phone number"
                      className="w-full border border-gray-300 rounded-2xl px-6 py-4 text-lg focus:outline-none focus:border-[#0a8082]"
                    />
                  </div>

                  <div>
                    <label className="block text-base sm:text-lg font-semibold text-[#071E56] mb-2 sm:mb-3">
                      Select Service
                    </label>

                    <select
                      name="service"
                      className="w-full border border-gray-300 rounded-2xl px-6 py-4 text-lg focus:outline-none focus:border-[#0a8082]"
                    >
                      <option>Website Development</option>
                      <option>Mobile App Development</option>
                      <option>ERP Software</option>
                      <option>eCommerce Solution</option>
                      <option>Digital Marketing</option>
                      <option>Custom Software</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-base sm:text-lg font-semibold text-[#071E56] mb-2 sm:mb-3">
                    Your Message
                  </label>

                  <textarea
                    rows={5}
                    name="message"
                    required
                    placeholder="Write your project requirement..."
                    className="w-full border border-gray-300 rounded-2xl px-6 py-4 text-lg focus:outline-none focus:border-[#0a8082]"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white px-6 sm:px-10 py-3 sm:py-5 rounded-full text-base sm:text-lg font-bold w-full sm:w-auto hover:scale-105 transition duration-300 shadow-2xl"
                >
                  Send Message 🚀
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
